import React from "react";
import CardHeader from "@material-ui/core/CardHeader";
import Typography from "@material-ui/core/Typography";
import PersonIcon from "@material-ui/icons/Person";
import EmployeeMenu from "./EmployeeMenu";

const EmployeeNameHeader = ({ user, children }) => {
  return (
    <CardHeader
      action={children}
      title={
        <Typography variant="body1" component="p" className="font-weight-bold">
          <PersonIcon /> {user.fname} {user.lname}
        </Typography>
      }
    />
  );
};

export default EmployeeNameHeader;
